export default "__VITE_ASSET__CzLoqxp3__"